import { ResourceActionExecution } from "@/services/cloudchipr.api";

export const getLastExecutionStatuses = (
  lastExecutionResults: ResourceActionExecution[],
): Record<"succeeded" | "failed" | "skipped", number> => {
  return lastExecutionResults.reduce(
    (statusCounts, result) => {
      result.resources.forEach(({ state }) => {
        if (state && state in statusCounts) {
          statusCounts[state] += 1;
        }
      });
      return statusCounts;
    },
    { succeeded: 0, failed: 0, skipped: 0 },
  );
};
